import { MODES } from '../constants';
import { types } from './actions';

const initialState = {
  customColumns: [],
  isDeleting: false,
  isLoading: false,
  isOpen: false,
  isSaving: false,
  mode: MODES.CREATE,
  product: null,
  purchasedComponent: null,
  purchasedComponentId: null,
  prefilledOemPartNumber: null,
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case types.CLOSE:
      return {
        ...initialState,
      };
    case types.DELETE_ERROR:
      return {
        ...state,
        isDeleting: false,
      };
    case types.DELETE_REQUEST:
      return {
        ...state,
        isDeleting: true,
      };
    case types.DELETE_SUCCESS:
      return {
        ...initialState,
      };
    case types.OPEN_ERROR:
      return {
        ...state,
        isLoading: false,
        isOpen: false,
      };
    case types.OPEN_REQUEST:
      return {
        ...state,
        purchasedComponentId: payload.purchasedComponentId ?? null,
        prefilledOemPartNumber: payload.prefilledOemPartNumber ?? null,
        mode: payload.mode,
        isLoading: true,
        isOpen: true,
      };
    case types.OPEN_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case types.SAVE_ERROR:
      return {
        ...state,
        isSaving: false,
      };
    case types.SAVE_REQUEST:
      return {
        ...state,
        isSaving: true,
      };
    case types.SAVE_SUCCESS:
      return {
        ...initialState,
      };
    case types.SET_CUSTOM_COLUMNS:
      return {
        ...state,
        customColumns: payload.customColumns,
      };
    case types.SET_PRODUCT:
      return {
        ...state,
        product: payload.product,
      };
    case types.SET_PURCHASED_COMPONENT:
      return {
        ...state,
        purchasedComponent: payload.purchasedComponent,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) =>
  state.modules.common.modals.purchasedComponentUpdateCreateModal;

export const getCustomColumns = (state) => getScope(state).customColumns;

export const getProduct = (state) => getScope(state).product;

export const getIsDeleting = (state) => getScope(state).isDeleting;

export const getIsLoading = (state) => getScope(state).isLoading;

export const getIsOpen = (state) => getScope(state).isOpen;

export const getIsSaving = (state) => getScope(state).isSaving;

export const getMode = (state) => getScope(state).mode;

export const getDefaultOemPartNumber = (state) =>
  getScope(state).prefilledOemPartNumber;

export const getPurchasedComponentId = (state) =>
  getScope(state).purchasedComponentId;

export const getPurchasedComponent = (state) =>
  getScope(state).purchasedComponent;
